var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg415K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 28,
    viewBox: "0 0 65 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_200_3113)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 28,
    rx: 10,
    fill: "#BAEAC8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0581 16.296V14.976L32.9821 9.36H34.9381V14.832H35.9941V16.296H34.9381V18H33.2581V16.296H29.0581ZM33.3661 11.16L30.9061 14.832H33.3661V11.16ZM36.8597 10.8V9.252H39.7517V18H38.0237V10.8H36.8597ZM47.2914 10.704H43.4034V12.756C43.5714 12.548 43.8114 12.38 44.1234 12.252C44.4354 12.116 44.7674 12.048 45.1194 12.048C45.7594 12.048 46.2834 12.188 46.6914 12.468C47.0994 12.748 47.3954 13.108 47.5794 13.548C47.7634 13.98 47.8554 14.444 47.8554 14.94C47.8554 15.86 47.5914 16.6 47.0634 17.16C46.5434 17.72 45.7994 18 44.8314 18C43.9194 18 43.1914 17.772 42.6474 17.316C42.1034 16.86 41.7954 16.264 41.7234 15.528H43.3554C43.4274 15.848 43.5874 16.104 43.8354 16.296C44.0914 16.488 44.4154 16.584 44.8074 16.584C45.2794 16.584 45.6354 16.436 45.8754 16.14C46.1154 15.844 46.2354 15.452 46.2354 14.964C46.2354 14.468 46.1114 14.092 45.8634 13.836C45.6234 13.572 45.2674 13.44 44.7954 13.44C44.4594 13.44 44.1794 13.524 43.9554 13.692C43.7314 13.86 43.5714 14.084 43.4754 14.364H41.8674V9.228H47.2914V10.704ZM53.262 18L51.006 15.168V18H49.326V9.12H51.006V14.172L53.238 11.352H55.422L52.494 14.688L55.446 18H53.262Z",
    fill: "#2A2A2B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_3113)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5002,
    r: 7.91667,
    stroke: "#2A2A2B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2502 9.75024C15.2502 9.33603 14.9144 9.00024 14.5002 9.00024C14.0859 9.00024 13.7502 9.33603 13.7502 9.75024V10.6163C13.3212 10.6662 12.8758 10.7818 12.4932 11.0201C12.0055 11.3238 11.6556 11.8079 11.5772 12.4677C11.5184 12.9628 11.5711 13.4178 11.7571 13.8193C11.944 14.2228 12.2377 14.5121 12.5606 14.72C13.1539 15.1019 13.9319 15.2546 14.5212 15.3702L14.5485 15.3755L14.5992 15.3855L14.5992 15.3855C14.9018 15.4448 15.1679 15.497 15.4088 15.5621C15.6646 15.6313 15.8411 15.7023 15.9579 15.7759C16.0639 15.8426 16.0938 15.8936 16.1074 15.9299C16.1237 15.9733 16.1517 16.0924 16.0885 16.3506C16.0576 16.4768 15.9737 16.5977 15.7399 16.7083C15.4896 16.8268 15.1247 16.9004 14.6811 16.9145C13.7758 16.9431 12.8386 16.7193 12.4748 16.5276C12.1084 16.3345 11.6548 16.475 11.4616 16.8415C11.2685 17.2079 11.409 17.6615 11.7755 17.8546C12.2359 18.0973 12.9738 18.2927 13.7502 18.3749V19.2502C13.7502 19.6645 14.0859 20.0002 14.5002 20.0002C14.9144 20.0002 15.2502 19.6645 15.2502 19.2502V18.3738C15.6406 18.325 16.0315 18.2299 16.3817 18.0641C16.9056 17.8161 17.3795 17.3852 17.5455 16.7073C17.6571 16.2515 17.6642 15.8083 17.5115 15.4021C17.3561 14.9888 17.069 14.703 16.7574 14.5067C16.4567 14.3173 16.1152 14.1992 15.8002 14.1141C15.506 14.0346 15.1904 13.9728 14.9025 13.9164L14.8375 13.9036C14.1725 13.7731 13.6875 13.6615 13.3726 13.4588C13.2368 13.3713 13.162 13.2834 13.1181 13.1888C13.0734 13.0922 13.0331 12.9282 13.0668 12.6446C13.0879 12.4668 13.1589 12.3726 13.2862 12.2933C13.4463 12.1936 13.7116 12.1158 14.0877 12.0915C14.8378 12.0431 15.7456 12.2241 16.3154 12.4157C16.708 12.5478 17.1333 12.3365 17.2654 11.9439C17.3974 11.5513 17.1862 11.126 16.7936 10.994C16.3871 10.8572 15.8373 10.7212 15.2502 10.6452V9.75024Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_200_3113",
    x: -200,
    y: -200,
    width: 465,
    height: 428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_200_3113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_200_3113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_3113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(5 5.00024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg415K);
export default __webpack_public_path__ + "static/media/415k.27568214273d785891efaf113732e944.svg";
export { ForwardRef as ReactComponent };